<template>
  <div class="detail-container">
    <!-- header -->
    <details-header :baseInfo="peopleInfoData"></details-header>
    <!-- content -->
    <div class="content views-report-content">
      <!-- 基础信息 -->
      <h2 class="small-title SysFontM">{{ $t("team.基础信息") }}</h2>
      <div class="base-container">
        <div
          class="base-item"
          v-for="base in peopleInfoData.fields"
          :key="base.id"
        >
          <div class="base-label">{{ base["name"] }}</div>
          <div class="base-value SysFontM">
            <cl-overflow-tooltip parent-class-name="base-value">{{
              base.value
            }}</cl-overflow-tooltip>
          </div>
        </div>
      </div>

      <!-- 视频资料 -->
      <template v-if="peopleInfoData.videos && peopleInfoData.videos.length">
        <h2 class="small-title SysFontM">{{ $t("ts.视频资料") }}</h2>
        <div class="video-info-container">
          <cl-file-list
            v-model="peopleInfoData.videos"
            :customizeDownLoad="true"
            :disabled="true"
            :showAnnex="false"
            :hasDownload="false"
          ></cl-file-list>
        </div>
      </template>

      <!-- 球员评分 -->
      <h2 class="small-title SysFontM">{{ $t("ts.球员评分") }}</h2>
      <div class="score-container" v-if="evaluation">
        <div class="total">
          {{ $t("ts.综合评分") }}
          <span class="total-score">
            {{ evaluation.total_score || "N/A" }}
          </span>
        </div>
        <pre class="score-detail">{{ evaluation.remark }}</pre>
        <div class="score-item-container">
          <cl-eval-view
            v-if="evaluation.dimension_list"
            :dimensionList="evaluation.dimension_list"
          ></cl-eval-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import detailsHeader from "./components/details-header.vue";
import showDynamicText from "@/mixins/showDynamicText.js";
export default {
  mixins: [showDynamicText],
  components: {
    detailsHeader,
  },
  data() {
    return {
      peopleInfoData: {},
      evaluation: {
        dimension_list: [],
      },
    };
  },

  mounted() {
    // 获取球探报告详情
    this.getReportInfo();
  },
  methods: {
    handleBack() {
      this.$router.push({
        path: "/telescope/report/index",
      });
    },

    async getReportInfo() {
      const scoutItem = JSON.parse(sessionStorage.getItem("scoutItem"));
      const positions = [
        {
          name: "前锋",
          description: "",
          nameEn: "STC",
          key: "STC",
        },
        {
          name: "左前锋",
          description: "",
          nameEn: "STCL",
          key: "STCL",
        },
        {
          name: "右前锋",
          description: "",
          nameEn: "STCR",
          key: "STCR",
        },
        {
          name: "右前卫",
          description: "",
          nameEn: "AMR",
          key: "AMR",
        },
        {
          name: "左前卫",
          description: "",
          nameEn: "AML",
          key: "AML",
        },
        {
          name: "中场: AMC",
          description: "",
          nameEn: "AMC",
          key: "AMC",
        },
        {
          name: "左中场: AMCL",
          description: "",
          nameEn: "AMCL",
          key: "AMCL",
        },
        {
          name: "右中场: AMCR",
          description: "",
          nameEn: "AMCR",
          key: "AMCR",
        },
        {
          name: "右前卫: MR",
          description: "",
          nameEn: "MR",
          key: "MR",
        },
        {
          name: "左前卫: ML",
          description: "",
          nameEn: "ML",
          key: "ML",
        },
        {
          name: "中前卫: MC",
          description: "",
          nameEn: "MC",
          key: "MC",
        },
        {
          name: "左中前卫: MCL",
          description: "",
          nameEn: "MCL",
          key: "MCL",
        },
        {
          name: "右中前卫: MCR",
          description: "",
          nameEn: "MCR",
          key: "MCR",
        },
        {
          name: "右边后卫: WBR",
          description: "",
          nameEn: "WBR",
          key: "WBR",
        },
        {
          name: "左边后卫: WBL",
          description: "",
          nameEn: "WBL",
          key: "WBL",
        },
        {
          name: "后腰: DM",
          description: "",
          nameEn: "DM",
          key: "DM",
        },
        {
          name: "左后腰: DMCL",
          description: "",
          nameEn: "DMCL",
          key: "DMCL",
        },
        {
          name: "右后腰: DMCR",
          description: "",
          nameEn: "DMCR",
          key: "DMCR",
        },
        {
          name: "右后卫: DR",
          description: "",
          nameEn: "DR",
          key: "DR",
        },
        {
          name: "左后卫: DL",
          description: "",
          nameEn: "DL",
          key: "DL",
        },
        {
          name: "中后卫: DC",
          description: "",
          nameEn: "DC",
          key: "DC",
        },
        {
          name: "左中后卫: DCL",
          description: "",
          nameEn: "DCL",
          key: "DCL",
        },
        {
          name: "右中后卫: DCR",
          description: "",
          nameEn: "DCR",
          key: "DCR",
        },
        {
          name: "守门员: GK",
          description: "",
          nameEn: "GK",
          key: "GK",
        },
      ];
      const { fields, ...other } = scoutItem;
      const setArrToStr = (data, v) => {
        let arr = [];
        const resV = typeof v === "string" ? [v] : v;
        resV.forEach((n) => {
          let item = data.find((m) => m.key === n);
          if (item) {
            arr.push(item["name"]);
          } else {
            arr.push(n);
          }
        });
        return arr.join();
      };
      const fieldsData = scoutItem.fields.map((item) => {
        item.property = JSON.parse(item.property || "{}");
        const value = item.data;
        if (item.type === "select") {
          item.value = setArrToStr(item.property.data, value);
        } else if (item.type === "dict") {
          const data = JSON.parse(item.data);
          item.value = setArrToStr(positions, data);
        } else {
          item.value = value;
        }
        return {
          name: item.name,
          value: item.value,
        };
      });
      this.evaluation = other.evaluation;
      this.peopleInfoData = { ...other, fields: fieldsData };
      console.log(this.peopleInfoData, "peopleInfoData");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./detail.scss";
</style>
